import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByDateQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByDateQueryType,
  AnalyticsSalesByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByDateQueryType,
    AnalyticsSalesByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByDateQueryType,
    AnalyticsSalesByDateQueryVariablesType
  >(AnalyticsSalesByDateQuery, options);
};
